import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {SaleService} from '../shared/services/sale.service'

// The money section.
//
// One period drives everything on the page: the totals, the per-content table and
// the register are all the same filter seen from three distances. Opening a row
// in the per-content table narrows the register to that item, because "how did
// this stream sell" is the question the old page could not answer at all.
@Component({
  selector: 'app-income-page',
  templateUrl: './income-page.component.html',
  styleUrls: ['./income-page.component.scss'],

})
export class IncomePageComponent implements OnInit, OnDestroy {

    periods = [
      {value: '7', label: '7 днів'},
      {value: '30', label: '30 днів'},
      {value: '90', label: '90 днів'},
      {value: 'all', label: 'Увесь час'}
    ]

    period:string = '30'
    kind:string = 'all'
    query:string = ''
    appliedQuery:string = ''
    contentFilter:any = null

    payouts:any[] = []
    byContent:any[] = []
    totals:any = {sold: 0, fee: 0, net: 0, count: 0}
    page:number = 1
    pages:number = 1
    loading:boolean = true

    private pSub$:Subscription = null
    private cSub$:Subscription = null

  constructor(private saleService: SaleService){
  }

  ngOnInit(){
    this.reload()
  }

  kindLabel(kind:string){
    if(kind === 'playlist'){ return 'Плейлист' }
    if(kind === 'donate'){ return 'Донат' }
    if(kind === 'video'){ return 'Відео' }
    return 'Трансляція'
  }

  setPeriod(value:string){
    if(this.period === value){ return }
    this.period = value
    this.page = 1
    this.reload()
  }

  setKind(value:string){
    this.kind = value
    this.page = 1
    this.loadPayouts()
  }

  applySearch(){
    this.appliedQuery = (this.query || '').trim()
    this.page = 1
    this.loadPayouts()
  }

  clearSearch(){
    this.query = ''
    this.appliedQuery = ''
    this.page = 1
    this.loadPayouts()
  }

  filterByContent(item:any){
    this.contentFilter = item
    this.page = 1
    this.loadPayouts()
  }

  clearContentFilter(){
    this.contentFilter = null
    this.page = 1
    this.loadPayouts()
  }

  goPage(page:number){
    if(page < 1 || page > this.pages){ return }
    this.page = page
    this.loadPayouts()
  }

  private reload(){
    this.loadByContent()
    this.loadPayouts()
  }

  private loadByContent(){
    if(this.cSub$){ this.cSub$.unsubscribe() }
    this.cSub$ = this.saleService.getPayoutsByContent(this.period).subscribe((res:any)=>{
      this.byContent = (res && res.ok) ? (res.items || []) : []
    }, ()=>{ this.byContent = [] })
  }

  private loadPayouts(){
    this.loading = true
    if(this.pSub$){ this.pSub$.unsubscribe() }

    this.pSub$ = this.saleService.getPayouts({
      period: this.period,
      kind: this.kind,
      q: this.appliedQuery,
      content: this.contentFilter ? this.contentFilter.id : '',
      page: this.page
    }).subscribe((res:any)=>{
      this.loading = false
      if(!res || !res.ok){ return }
      this.payouts = res.items || []
      // The totals belong to the same filter as the rows, so a filtered view never
      // shows a total that includes what it is hiding.
      this.totals = res.totals || {sold: 0, fee: 0, net: 0, count: 0}
      this.pages = res.pages || 1
      this.page = res.page || 1
    }, ()=>{ this.loading = false })
  }

  ngOnDestroy(){
    if(this.pSub$){ this.pSub$.unsubscribe() }
    if(this.cSub$){ this.cSub$.unsubscribe() }
  }

}
